var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBankIcon = function SvgBankIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#040721"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 11V11.625C25.375 11.7079 25.3421 11.7874 25.2835 11.846C25.2249 11.9046 25.1454 11.9375 25.0625 11.9375H24.125V12.4063C24.125 12.6651 23.9151 12.875 23.6562 12.875H8.34375C8.08488 12.875 7.875 12.6651 7.875 12.4063V11.9375H6.9375C6.85462 11.9375 6.77513 11.9046 6.71653 11.846C6.65792 11.7874 6.625 11.7079 6.625 11.625V11C6.625 10.9382 6.64334 10.8778 6.6777 10.8264C6.71205 10.775 6.76088 10.7349 6.81801 10.7113L15.8805 7.27376C15.957 7.24208 16.043 7.24208 16.1195 7.27376L25.182 10.7113C25.2391 10.7349 25.2879 10.775 25.3223 10.8264C25.3567 10.8778 25.375 10.9382 25.375 11ZM24.4375 22.875H7.5625C7.04473 22.875 6.625 23.2947 6.625 23.8125V24.4375C6.625 24.5204 6.65792 24.5999 6.71653 24.6585C6.77513 24.7171 6.85462 24.75 6.9375 24.75H25.0625C25.1454 24.75 25.2249 24.7171 25.2835 24.6585C25.3421 24.5999 25.375 24.5204 25.375 24.4375V23.8125C25.375 23.2947 24.9553 22.875 24.4375 22.875ZM9.75 13.5V21H8.34375C8.08488 21 7.875 21.2099 7.875 21.4688V22.25H24.125V21.4688C24.125 21.2099 23.9151 21 23.6562 21H22.25V13.5H19.75V21H17.25V13.5H14.75V21H12.25V13.5H9.75Z",
    fill: "#F9DA87"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBankIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bank_icon.e36061b2d783427c0295a0ab29aa8c9b.svg";